import { useEffect, useRef, useState, useContext } from "react";
import authservices, { verifyAuth } from "../services/authservices";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const Tradebot = () => {
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  const [siteDatacomes, setSiteData] = useState("");

  const [loginCheck, setloginCheck] = useState(false);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    getSitedata();

    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };
  return (
    <>
      <main className="wyscale_landing_main">
        <section>
          <Header />
        </section>
        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="privacy-condition">
              <h2>{t("WhatIsBinargeTradeBotAndWhyIsItUnique")}</h2>
              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">
                      <h3>1. {t("FullyAutomated")}</h3>
                      <p>{t("BinargeIsASmartCrypto")}</p>
                      <p>{t("UnlikeManyOtherCryptoBots")}</p>
                      <p>{t("AFullyAutomated")}</p>

                      <h3>2. {t("LowRiskStrategiesDesigned")}</h3>

                      <ul>
                        <li>{t("MostBotsFocusOnSpeculativeTrading")}</li>
                        <li>{t("BinargeUsesArbitrage")}</li>
                      </ul>

                      <h3>3. {t("MultipleExchanges")}</h3>

                      <ul>
                        <li>{t("BinargeWorks")}</li>
                        <li>{t("TakeAdvantage")}</li>
                      </ul>

                      <h3>4. {t("QuickSetupGet")}</h3>

                      <ul>
                        <li>{t("NoPreviousTradingExperienceRequired")}</li>
                        <li>{t("Register")}</li>
                      </ul>

                      <p>{t("BinargeIsDesignedForEveryone")}</p>
                      <p>{t("LetTheSmartBotDoTheWork")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="footer_section">
          <div className="container">
            <section className="row mx-0 bn-footer-row g-4 g-lg-1">
              <div className="col-lg-6 col-sm-6 col-12">
                <div>
                  <img
                    src={require("./img/footer-logo.webp")}
                    alt=""
                    className="bn-footer-logo"
                  />
                  <p className="bn-footer-logo-content">
                    {t("AIPoweredCryptoTrading")}
                  </p>
                </div>
              </div>
              <div className="col-lg-2 col-sm-4 col-6">
                <h6 className="bn-footer-link-title">{t("Explore")}</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                      <Link to="/" className="bn-footer-links">
                        Newbies
                      </Link>
                    </li>
                    <li>
                      <Link to="/" className="bn-footer-links">
                        Knowledge Base
                      </Link>
                    </li>
                    <li>
                      <Link to="/" className="bn-footer-links">
                        Strategies
                      </Link>
                    </li> */}
                  <li>
                    <Link to="/termscondition" className="bn-footer-links">
                      {t("TermsAndService")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy" className="bn-footer-links">
                      {t("PrivacyPolicy")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/disclaimer" className="bn-footer-links">
                      {t("Disclaimer")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-guide" className="bn-footer-links">
                      {t("UserGuide")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/affiliate" className="bn-footer-links">
                      {t("Affiliate")}
                    </Link>
                  </li>{" "}
                  <li>
                    <Link to="/fuel-wallet" className="bn-footer-links">
                      {t("FuelWallet")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tradebot" className="bn-footer-links">
                      {t("TradeBot")}
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">{t("Support")}</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                                 <Link to="/" className="bn-footer-links">
                                   Terms & Conditions
                                 </Link>
                               </li>
                               <li>
                                 <Link to="/" className="bn-footer-links">
                                   Privacy Policy
                                 </Link>
                               </li> */}
                  <li>
                    <Link
                      to={loginCheck ? "/support" : "/login"}
                      className="bn-footer-links"
                    >
                      {t("HelpCenter")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">{t("Social")}</h6>
                <ul className="bn-footer-icon-wrap">
                  <li>
                    <a target="_blank" href={siteDatacomes.instagram}>
                      <img src={require("./img/instagram.webp")} alt="" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href={siteDatacomes.twitter}>
                      <img src={require("./img/x.webp")} alt="" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href={siteDatacomes.telegram}>
                      <img src={require("./img/telegram.webp")} alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </section>
          </div>
        </section>
        <div className="footer_last">
          <span className="footer_copyrights">©{t("AllRightsReserved")}</span>
        </div>
      </main>
    </>
  );
};

export default Tradebot;
